import { array, literal, object, TypeOf, union } from 'zod';

import { AgeRating } from './age-rating';
import { Collection } from './collection';
import { Classification } from './common';
import { Label } from './label';
import { Product } from './product';

/* ----------------------------- SectionProduct ----------------------------- */

export const SectionProduct = Product.and(
    object({
        classification: literal(Classification.Product),
        rating: AgeRating.optional(),
        itemLabel: Label.optional(),
        tileLabel: Label.optional(),
    }),
);
export type SectionProduct = TypeOf<typeof SectionProduct>;

/* ---------------------------- SectionCollection --------------------------- */

export const SectionCollection = Collection.and(
    object({
        classification: literal(Classification.Collection),
        itemLabel: Label.optional(),
        tileLabel: Label.optional(),
    }),
);
export type SectionCollection = TypeOf<typeof SectionCollection>;

/* ----------------------------- SectionChildren ---------------------------- */

export const SectionChildren = union([SectionProduct, SectionCollection]);
export type SectionChildren = TypeOf<typeof SectionChildren>;

/* --------------------------------- Section -------------------------------- */

export const Section = Collection.extend({
    children: array(SectionChildren),
});
export type Section = TypeOf<typeof Section>;
